import React from "react";
import { useParams } from "react-router-dom";

// Import all your report components
import POIReport from "./POIReport";
import  TripReport from "./TripReport";
import ConsolidatedReport from "./ConsolidatedReport"
import currentReport from "./CurrentSummaryReport"
import canReport from "./CanReport";
import obdReport from "./OBDReport"
import alertReport from "./alertReport"
import panicReport from "./PanicReport"
// import ConsolidatedReport from "./ConsolidatedReport";
// import SummaryReport from "./SummaryReport";
// Import other report components...

const reportComponents = {
  poi: POIReport,
  trip:TripReport,
  consolidated: ConsolidatedReport,
   summary: currentReport,
   can:canReport,
  obd: obdReport,
  alert:alertReport,
  panic:panicReport,
  // Add other report mappings...
};

export default function ReportViewer() {
  const { reportId } = useParams();
  const ReportComponent = reportComponents[reportId];

  if (!ReportComponent) {
    return <div>Report not found</div>;
  }

  return <ReportComponent />;
}